<!--
  Aktionsseite (Kramermarkt): kompaktes Kurzformular für Anfragen zu den
  Partyreisen ins Zillertal. Ohne Banner, damit das Formular direkt sichtbar ist.
  Die Termine (Einfachauswahl) kommen als `dates` vom PageController.
-->
<template>
  <layout
    title="Partyreisen ins Zillertal"
    metaDescription="Unsere Partyreisen ins Zillertal im Dezember 2026 und März 2027 – jetzt schnell und unverbindlich anfragen."
    metaKeywords="SCOL, SCOL Skireisen, Partyreise, Partyreisen Zillertal, Skireise Party, Aktion"
    compactHeader
  >
    <section id="aktion-form" class="scol-section">
      <div class="container container-small">
        <div class="text-center mb-4">
          <h1 class="h2">Unsere Partyreisen ins Zillertal</h1>
        </div>

        <div v-if="form.feedback.show" class="text-center">
          <div class="alert alert-success" role="alert">
            {{ form.feedback.message }}
          </div>
        </div>

        <form v-if="form.show" @submit.prevent="submit()">
          <div class="mb-3">
            <div
              v-for="(label, key) in dates"
              :key="key"
              class="form-check mb-2"
            >
              <input
                v-model="form.termin"
                class="form-check-input"
                :class="{ 'is-invalid': form.errors.termin }"
                type="radio"
                name="termin"
                :value="key"
                :id="'aktion-termin-' + key"
              />
              <label class="form-check-label" :for="'aktion-termin-' + key">
                {{ label }}
              </label>
            </div>
            <div class="invalid-feedback d-block" v-if="form.errors.termin">
              {{ form.errors.termin }}
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  v-model="form.vorname"
                  class="form-control rounded-0"
                  :class="{ 'is-invalid': form.errors.vorname }"
                  id="aktion-vorname"
                  placeholder="Vorname"
                  autocomplete="given-name"
                />
                <label for="aktion-vorname">Vorname*</label>
                <div class="invalid-feedback" v-if="form.errors.vorname">
                  {{ form.errors.vorname }}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-floating mb-3">
                <input
                  type="text"
                  v-model="form.nachname"
                  class="form-control rounded-0"
                  :class="{ 'is-invalid': form.errors.nachname }"
                  id="aktion-nachname"
                  placeholder="Nachname"
                  autocomplete="family-name"
                />
                <label for="aktion-nachname">Nachname*</label>
                <div class="invalid-feedback" v-if="form.errors.nachname">
                  {{ form.errors.nachname }}
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-floating mb-3">
                <input
                  type="tel"
                  v-model="form.telefon"
                  class="form-control rounded-0"
                  :class="{ 'is-invalid': form.errors.telefon }"
                  id="aktion-telefon"
                  placeholder="Telefon"
                  autocomplete="tel"
                />
                <label for="aktion-telefon">Telefon*</label>
                <div class="invalid-feedback" v-if="form.errors.telefon">
                  {{ form.errors.telefon }}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-floating mb-3">
                <input
                  type="email"
                  v-model="form.email"
                  class="form-control rounded-0"
                  :class="{ 'is-invalid': form.errors.email }"
                  id="aktion-email"
                  placeholder="E-Mail"
                  autocomplete="email"
                />
                <label for="aktion-email">E-Mail*</label>
                <div class="invalid-feedback" v-if="form.errors.email">
                  {{ form.errors.email }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-check mt-2">
            <input
              v-model="form.datenschutz"
              class="form-check-input rounded-0"
              :class="{ 'is-invalid': form.errors.datenschutz }"
              type="checkbox"
              id="aktion-datenschutz"
            />
            <label class="form-check-label" for="aktion-datenschutz">
              <small
                >Ich stimme zu, dass die Angaben in dem Anfrageformular inklusive
                der dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage
                und für den Fall von Anschlussfragen bei uns gespeichert werden.
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</small
              >
            </label>
            <div class="invalid-feedback" v-if="form.errors.datenschutz">
              {{ form.errors.datenschutz }}
            </div>
          </div>

          <div class="text-center">
            <button
              type="submit"
              class="mt-4 btn btn-primary rounded-pill px-5"
              :disabled="form.processing"
            >
              <i class="far fa-paper-plane"></i> Absenden
            </button>
          </div>
        </form>
      </div>
    </section>
  </layout>
</template>

<script>
import { useForm } from "@inertiajs/inertia-vue3";
import Layout from "./Layouts/Standard";

export default {
  components: {
    Layout,
  },
  props: {
    dates: Object,
  },
  setup() {
    const form = useForm({
      show: true,
      termin: null,
      vorname: null,
      nachname: null,
      telefon: null,
      email: null,
      datenschutz: null,
      feedback: {
        show: false,
        message: "",
      },
    });

    const submit = () => {
      form.post(route("campaign.store"), {
        preserveScroll: true,
        onSuccess: () => {
          form.reset();
          form.show = false;
          form.feedback = {
            show: true,
            message:
              "Vielen Dank für deine Anfrage! Wir melden uns schnellstmöglich bei dir.",
          };
        },
      });
    };

    return { form, submit };
  },
};
</script>
